const platformAdmin = {
  search: '検索',
  chat: 'チャット',
  drbfm: 'DRBFM',
  cad: 'CAD',

  本契約: '本契約',
  トライアル: 'トライアル',
  停止中: '停止中',
  アーカイブ: 'アーカイブ',
  '読み込みに失敗しました。': '読み込みに失敗しました。',
  未確認: '未確認',
  'Microsoft認証が完了しませんでした。再度ログインしてください。':
    'Microsoft認証が完了しませんでした。再度ログインしてください。',
  '認証を確認できませんでした。再度ログインしてください。':
    '認証を確認できませんでした。再度ログインしてください。',
  'Entra IDの設定がありません。管理者に確認してください。':
    'Entra IDの設定がありません。管理者に確認してください。',
  'AIONA 横断管理': 'AIONA 横断管理',
  'Entra IDでログインしてください。': 'Entra IDでログインしてください。',
  'Entra IDでログイン': 'Entra IDでログイン',
  対象環境: '対象環境',
  読み込み中: '読み込み中',
  ログアウト: 'ログアウト',
  '環境設定を読み込み中…': '環境設定を読み込み中…',
  '対象環境:': '対象環境: ',
  'のアクセス権を確認中…': 'のアクセス権を確認中…',
  管理メニュー: '管理メニュー',
  テナント: 'テナント',
  新規トライアル: '新規トライアル',
  操作履歴: '操作履歴',
  'この環境では変更操作が許可されていません。': 'この環境では変更操作が許可されていません。',
  集計済み: '集計済み',
  集計が古いため利用件数は未確認です: '集計が古いため利用件数は未確認です',
  必要期間が未集計のため利用件数は未確認です: '必要期間が未集計のため利用件数は未確認です',
  '／ 最終成功:': '／ 最終成功: ',
  '／ 集計対象末尾:': '／ 集計対象末尾: ',
  '機能別件数: 直近7日の監査イベント。利用人数: 直近7日の重複なしユーザー数。ユーザー別件数: 直近30日。':
    '機能別件数: 直近7日の監査イベント。利用人数: 直近7日の重複なしユーザー数。ユーザー別件数: 直近30日。',
  テナント一覧: 'テナント一覧',
  'テナントがありません。': 'テナントがありません。',
  テナント名: 'テナント名',
  状態: '状態',
  期限: '期限',
  直近7日の利用件数: '直近7日の利用件数',
  件: '件',
  '読み込み中…': '読み込み中…',
  '／ 対象環境:': '／ 対象環境: ',
  '契約・担当者': '契約・担当者',
  '状態:': '状態: ',
  '／ 期限:': '／ 期限: ',
  '担当者:': '担当者: ',
  '／ 営業:': '／ 営業: ',
  '主要機能の利用（直近7日）': '主要機能の利用（直近7日）',
  利用ユーザー: '利用ユーザー',
  人: '人',
  最近の動き: '最近の動き',
  'ユーザー別利用（直近30日・監査ログ）': 'ユーザー別利用（直近30日・監査ログ）',
  ユーザー: 'ユーザー',
  利用件数: '利用件数',
  保存済みデータ: '保存済みデータ',
  チャット: 'チャット',
  'スレッド ／': 'スレッド ／',
  'メッセージ ／ DRBFM': 'メッセージ ／ DRBFM',
  'この環境は閲覧のみです。': 'この環境は閲覧のみです。',
  '記録がありません。': '記録がありません。',
  日時: '日時',
  操作: '操作',
  結果: '結果',
  管理者: '管理者',
  期限延長: '期限延長',
  停止: '停止',
  '再開（本契約）': '再開（本契約）',
  個別データ削除: '個別データ削除',
  管理操作: '管理操作',
  理由: '理由',
  チャット履歴: 'チャット履歴',
  'アップロード文書は対象外です。削除は元に戻せません。':
    'アップロード文書は対象外です。削除は元に戻せません。',
  内容を確認: '内容を確認',
  管理操作の確認: '管理操作の確認',
  の確認: 'の確認',
  '／ テナント:': '／ テナント: ',
  '理由:': '理由: ',
  '期限:': '期限: ',
  '削除対象:': '削除対象: ',
  キャンセル: 'キャンセル',
  '実行中…': '実行中…',
  で実行: 'で実行',
  会社名: '会社名',
  テナントコード: 'テナントコード',
  初期管理者メール: '初期管理者メール',
  担当者メール: '担当者メール',
  CS担当メール: 'CS担当メール',
  営業担当メール: '営業担当メール',
  メモ: 'メモ',
  トライアル作成の確認: 'トライアル作成の確認',
  '機能:': '機能: ',
  なし: 'なし',
  で作成: 'で作成',
  '管理APIの環境設定が不正です。': '管理APIの環境設定が不正です。',
  '現在の環境が設定されていません。': '現在の環境が設定されていません。',
  '選択環境と管理APIの環境が一致しません。': '選択環境と管理APIの環境が一致しません。',
  デモ: 'デモ',
  本番: '本番',
  検索: '検索',
  アップロード: 'アップロード',
  失敗: '失敗',
  requestFailed:
    '管理APIにアクセスできません ({{status}})。選択環境の認証・権限・接続を確認してください。',
};
export default platformAdmin;
